<template>
  <n-card title="Página Inicial">
    <p>Bem-vindo ao seu painel Vue + Naive UI 🎉</p>
    <n-button type="primary" @click="showMessage">Mostrar mensagem</n-button>
  </n-card>
</template>

<script setup>
import { useMessage } from 'naive-ui'
const message = useMessage()
function showMessage() {
  message.success('Tudo funcionando corretamente!')
}
</script>
